import type { IMessage, InputToolbarProps } from 'react-native-gifted-chat';

import { StyleSheet } from 'react-native';

import { getColorTokenValue } from '@utility-nyc/react-native-ui-config';
import { InputToolbar } from 'react-native-gifted-chat';
import { useMedia } from 'tamagui';

import { getSizeTokenValue } from '@south-street-app/theme';

const styles = StyleSheet.create({
  inputPrimaryStyle: {
    backgroundColor: '#FFFFFF',
    borderColor: getColorTokenValue('$mono300'),
    borderWidth: 1,
    borderRadius: 18,
    minHeight: getSizeTokenValue('$14'),
    alignItems: 'flex-end',
    paddingHorizontal: getSizeTokenValue('$3'),
    paddingVertical: getSizeTokenValue('$2'),
  },
  inputContainerStyle: {
    backgroundColor: 'transparent',
    padding: getSizeTokenValue('$1'),
    borderTopWidth: 0,
  },
  inputContainerStyleDesktop: {
    backgroundColor: 'transparent',
    padding: getSizeTokenValue('$4'),
    borderTopWidth: 0,
    justifyContent: 'flex-end',
  },
});

const ChatInput = (props: InputToolbarProps<IMessage>) => {
  const { desktop } = useMedia();

  return (
    <InputToolbar
      {...props}
      primaryStyle={styles.inputPrimaryStyle}
      containerStyle={
        desktop ? styles.inputContainerStyleDesktop : styles.inputContainerStyle
      }
    />
  );
};

export { ChatInput };
